import { Box, BoxProps, styled } from "@mui/material";
import { rem } from "polished";
import React, { ReactNode } from "react";
import { NavLink, To } from "react-router-dom";

type Props = {
  links: Array<{ label: string; link: To }>;
  leftNode?: ReactNode;
} & BoxProps;

const StyledLinkWraper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$withLeftNode",
})<{ $withLeftNode: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.$withLeftNode ? "flex-start" : "center")};
  padding: 0 ${(props) => props.theme.spacing(2)};
  border-bottom: ${rem(1)} solid ${(props) => props.theme.palette.gray.background};
  background-color: ${(props) => props.theme.palette.primary.light};

  ${(props) => props.theme.breakpoints.down("md")} {
    flex-direction: column;
    padding: ${(props) => props.theme.spacing(2)};
  }

  & > a {
    position: relative;
    text-decoration: none;
    margin: 0 ${(props) => props.theme.spacing(0.5)};
    padding: 1.5rem 0.5rem;
    color: ${(props) => props.theme.palette.text.primary};
    font-weight: 500;
    text-align: center;

    &:hover,
    &.active {
      color: ${(props) => props.theme.palette.secondary.main};
    }

    &.active {
      &:after {
        position: absolute;
        content: "";
        height: ${rem(4)};
        left: 0;
        right: 0;
        bottom: ${rem(-2)};
        background-color: ${(props) => props.theme.palette.secondary.main};
      }
    }
  }
`;

export const SubNav = ({ links, leftNode, ...boxProps }: Props) => {
  return (
    <StyledLinkWraper
      $withLeftNode={!!leftNode}
      component="nav"
      role="navigation"
      data-cy="sub-nav"
      sx={{
        justifyContent: leftNode ? "flex-start" : "center",
        ...boxProps.sx,
      }}
      {...boxProps}
    >
      {leftNode && <>{leftNode}</>}
      {leftNode && <Box sx={{ flex: 0.3 }} />}
      {links.map((item, index) => (
        <NavLink key={index} to={item.link}>
          {item.label}
        </NavLink>
      ))}
    </StyledLinkWraper>
  );
};
